import { i18n } from '../i18n'

// This is meant to be a generic function to validate forms, and should be shared between PublicApp and StandardApp
// Sets formElement.dynamicTypeData.isValid = false/false And formElement.dynamicTypeData.errorText = "..."
// Returns true if valid
export function validateForm(formRegistration) {
      let errorInForm = false;
      for (let i in formRegistration.formElements) {
        var formElement = formRegistration.formElements[i];
        
        var errorText = ""
        //console.log('Type: ' + formElement.type + " required: " + formElement.dynamicTypeData.required + " Value: " + formElement.dynamicTypeData.value)

        formElement.dynamicTypeData.isValid = true
        if(formElement.type === "text" || formElement.type === "textarea") {                    
            if (formElement.dynamicTypeData.required && (formElement.dynamicTypeData.value === null || formElement.dynamicTypeData.value === "")) {
                formElement.dynamicTypeData.isValid = false

                errorText = i18n.tc('form.invalidValueMandatory')
            }
            else if(formElement.dynamicTypeData.value) {
                if(formElement.dynamicTypeData.min)
                {
                    var min = parseInt(formElement.dynamicTypeData.min)
                    if(formElement.dynamicTypeData.value.length < min)
                    {
                        errorText =  i18n.tc('form.invalidValueMinValueText') + min + i18n.tc('form.invalidValueTextLength')
                        formElement.dynamicTypeData.isValid = false   
                    }
                }

                if(formElement.dynamicTypeData.max)
                {
                    var max = parseInt(formElement.dynamicTypeData.max)
                    if(formElement.dynamicTypeData.value.length > max)
                    {
                        errorText = i18n.tc('form.invalidValueMaxValueText') + max + i18n.tc('form.invalidValueTextLength')
                        formElement.dynamicTypeData.isValid = false
                    }
                }
            }
            else {
                /*if(formElement.dynamicTypeData.min && formElement.dynamicTypeData.min != "0") {
                    formElement.dynamicTypeData.isValid = false
                    var min = parseInt(formElement.dynamicTypeData.min)
                    errorText =  i18n.tc('form.invalidValueMinValueText') + min + i18n.tc('form.invalidValueTextLength')
                        
                }
                else if(formElement.dynamicTypeData.max && formElement.dynamicTypeData.max != "0") {
                    formElement.dynamicTypeData.isValid = false
                    var max = parseInt(formElement.dynamicTypeData.max)
                    errorText = i18n.tc('form.invalidValueMaxValueText') + max + i18n.tc('form.invalidValueTextLength')
                }*/
            }
        }                
        else if(formElement.type === "number") {
            if (formElement.dynamicTypeData.required && (formElement.dynamicTypeData.value === null || formElement.dynamicTypeData.value === "")) {
                formElement.dynamicTypeData.isValid = false
                
                errorText = i18n.tc('form.invalidValueMandatory')
            }
            else if(formElement.dynamicTypeData.value) {
                var inputNumber = parseInt(formElement.dynamicTypeData.value)
                if(formElement.dynamicTypeData.min && formElement.dynamicTypeData.min != "0")
                {
                    var min = parseInt(formElement.dynamicTypeData.min)
                    if(inputNumber < min)
                    {
                        errorText = i18n.tc('form.invalidValueMinValue') + min                        
                        formElement.dynamicTypeData.isValid = false
                    }
                }

                if(formElement.dynamicTypeData.max && formElement.dynamicTypeData.max != "0")
                {
                    var max = parseInt(formElement.dynamicTypeData.max)
                    if(inputNumber > max)
                    {
                        errorText = i18n.tc('form.invalidValueMaxValue') + max
                        formElement.dynamicTypeData.isValid = false
                    }
                }
            } else {
                /*if(formElement.dynamicTypeData.min && formElement.dynamicTypeData.min != "0") {
                    formElement.dynamicTypeData.isValid = false
                    var min = parseInt(formElement.dynamicTypeData.min)
                    errorText = i18n.tc('form.invalidValueMinValue') + min                        
                }
                else if(formElement.dynamicTypeData.max && formElement.dynamicTypeData.max != "0") {
                    formElement.dynamicTypeData.isValid = false
                    var max = parseInt(formElement.dynamicTypeData.max)
                    errorText = i18n.tc('form.invalidValueMaxValue') + max
                }*/
            }
        }
        else if(formElement.type == "date") {
            if (formElement.dynamicTypeData.required &&  (formElement.dynamicTypeData.value === null || formElement.dynamicTypeData.value === "")) {
                formElement.dynamicTypeData.isValid = false
                
                errorText = i18n.tc('form.invalidValueMandatory')
            }
            else if (formElement.dynamicTypeData.value) {
                const valueChangedDate = formElement.dynamicTypeData.value.replace(/(..)\-(..)\-(....) (..):(..)/, '$3-$2-$1 $4:$5');
                var valueDate = moment(valueChangedDate, 'YYYY-MM-DD').toDate()
                valueDate = new Date(valueDate.toDateString())
                if(formElement.dynamicTypeData.min)
                {
                    const changedDate = formElement.dynamicTypeData.min.replace(/(..)\-(..)\-(....) (..):(..)/, '$3-$2-$1 $4:$5');
                    var min = moment(changedDate, 'YYYY-MM-DD').toDate()
                    min = moment(min, 'YYYY-MM-DD').toDate()
                    if(valueDate < min)
                    {
                        errorText = i18n.tc('form.invalidValueMinValue') + moment(min).format('DD-MM-YYYY')
                        formElement.dynamicTypeData.isValid = false
                    }
                }

                if(formElement.dynamicTypeData.max)
                {
                    const changedDate = formElement.dynamicTypeData.max.replace(/(..)\-(..)\-(....) (..):(..)/, '$3-$2-$1 $4:$5');
                    var max = moment(changedDate, 'YYYY-MM-DD').toDate()
                    max = moment(max, 'YYYY-MM-DD').toDate()
                    if(valueDate > max)
                    {
                        errorText = i18n.tc('form.invalidValueMaxValue') + moment(max).format('DD-MM-YYYY')
                        formElement.dynamicTypeData.isValid = false
                    }    
                }
            }    
        } 
        else if(formElement.type == "toggle" || formElement.type == "radiobutton" || formElement.type == "select") {
            if (formElement.dynamicTypeData.required && 
                (formElement.dynamicTypeData.selectedIndex === null ||
                formElement.dynamicTypeData.selectedIndex === - 1)) {
                errorText = i18n.tc('form.invalidValueMandatory')
                formElement.dynamicTypeData.isValid = false
            }
        }
        else {
            if (formElement.dynamicTypeData.required && 
                formElement.dynamicTypeData.value === null && 
                formElement.dynamicTypeData.selectedIndex === null &&
                formElement.dynamicTypeData.selectedIndexList.length <= 1) {
                formElement.dynamicTypeData.isValid = false
                errorText = i18n.tc('form.invalidValueMandatory')
            }
        }

        if(!formElement.dynamicTypeData.isValid) {
          errorInForm = true;
          formElement.dynamicTypeData.errorText = errorText;
        }
      }

      return !errorInForm;
}